import { render, staticRenderFns } from "./license_issue_body.vue?vue&type=template&id=61dcf7e4&"
import script from "./license_issue_body.vue?vue&type=script&lang=js&"
export * from "./license_issue_body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports